import React from 'react'
import clsx from 'clsx'
//import I18n from 'i18n-js/index.js.erb'
class GroupContractBuilderReservations extends React.Component {

  constructor(props) {
    super(props);
  }

  /*******************
  * Render functions *
  ********************/

  render() {
    var self = this;
    var tabClasses = clsx({
      'active': this.props.active_tab == 'reservations',
      'tab-pane': true
    });
    var reservation_ids = [];
    var child_reservations = this.props.reservation_segments.map(function (reservation_segment) {
      if (reservation_segment.reservation.id != self.props.reservation.id) {
        if (reservation_ids.indexOf(reservation_segment.reservation.id) == -1) {
          reservation_ids.push(reservation_segment.reservation.id);
          return <li key={reservation_segment.reservation.id}>{self.renderReservation(reservation_segment.reservation)}</li>
        } else {
          return null;
        }
      } else {
        return null;
      }
    }).filter(function (el) {
      return el != null;
    });

    return (
      <div className={tabClasses} id="reservations">
        {this.renderPrintButton()}
        <div className="row">
          <div className="col-md-12" style={{marginBottom: 0}}>
            <h5 className="panel-heading-text">{I18n.t('master_reservation')}</h5>
            {this.renderReservation(this.props.reservation)}
            <hr />
            <h5 className="panel-heading-text">{I18n.t('child_reservations')}</h5>
            {child_reservations.length > 0 ? <ul className="child-reservations">{child_reservations}</ul> : <span className="none">{I18n.t('none')}</span>}
          </div>
        </div>
      </div>  
    );
  }

  renderReservation(reservation) {
    return (
      <div className="reservation-summary" key={reservation.id}>
        <strong>{I18n.t('confirmation')}:</strong> #{reservation.confirmation_number}
        <br />
        <strong>{I18n.t('total')}:</strong> {I18n.t('number.currency.format.unit')}{numeral(reservation.total_amount / 100).format('0,000.00')}
        <br />
        <a href={reservation.path} className="modal-iframe" data-fullscreen="true" data-nested="true">{I18n.t('view_edit')}</a>
      </div>
    );
  }

  renderPrintButton() {
    if (this.props.print_button) {
      return (
        <div className="print-new-window" style={{position: 'absolute', top: -5, right: 0}}>
          <button className="btn btn-dark" title={I18n.t('print')}><span className="ss-print"></span></button>
        </div>
      );
    } else {
      return null;
    }
  }
};
export default GroupContractBuilderReservations